module.exports = __webpack_public_path__ + "img/vote-bad.91612578.svg";